import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { ItemTypesService } from 'src/services/data/item-types.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createItemType, createItemTypeFailure, createItemTypeSuccess, deleteItemType, deleteItemTypeFailure, deleteItemTypeSuccess, loadItemTypes, loadItemTypesFailure, loadItemTypesSuccess, updateItemType, updateItemTypeFailure, updateItemTypeSuccess } from './item-type.actions'

@Injectable()
export class ItemTypeEffects {
  private actions$ = inject(Actions)
  private ItemTypes = inject(ItemTypesService)
  private toaster = inject(ToasterService)


  loadItemTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadItemTypes),
    switchMap(() =>
      from(this.ItemTypes.getItemTypes()).pipe(
        map(itemTypes => loadItemTypesSuccess({ itemTypes })),
        catchAndLog(this.toaster, 'Unable to fetch itemTypes', loadItemTypesFailure)))))

  createItemType$ = createEffect(() => this.actions$.pipe(
    ofType(createItemType),
    tap(() => this.toaster.progress('Creating item type...')),
    switchMap(action =>
      from(this.ItemTypes.create(action.itemType)).pipe(
        map(itemType => createItemTypeSuccess({ itemType })),
        tap(() => this.toaster.success('Item Type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create document itemType', createItemTypeFailure)))))

  updateItemType$ = createEffect(() => this.actions$.pipe(
    ofType(updateItemType),
    tap(() => this.toaster.progress('Updating item type...')),
    switchMap(action =>
      from(this.ItemTypes.update({ ...action.itemType, item_type_id: action.id })).pipe(
        map(itemType => updateItemTypeSuccess({ itemType })),
        tap(() => this.toaster.success('Item Type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update document itemType', updateItemTypeFailure)))))

  deleteItemType$ = createEffect(() => this.actions$.pipe(
    ofType(deleteItemType),
    tap(() => this.toaster.progress('Deleting item type...')),
    switchMap(action =>
      from(this.ItemTypes.remove(action.itemType)).pipe(
        map(r => deleteItemTypeSuccess({ id: action.id })),
        tap(() => this.toaster.success('Item Type deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete document itemType', deleteItemTypeFailure)))))
}
